import { render, staticRenderFns } from "./vshopuserrecord.vue?vue&type=template&id=a32bacec&scoped=true"
import script from "./vshopuserrecord.vue?vue&type=script&lang=js"
export * from "./vshopuserrecord.vue?vue&type=script&lang=js"
import style0 from "./vshopuserrecord.vue?vue&type=style&index=0&id=a32bacec&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a32bacec",
  null
  
)

export default component.exports